import { navItems } from './nav-items'

# Tablet/desktop menu: a bar fixed across the top of the page. Over the header
# photo it sits on a dark gradient with white links; once the page scrolls it
# turns solid white with dark links. "More" opens a dropdown.
tag nav-topbar
	prop selected\string = ""
	scrolled = false
	moreOpen = false

	def onScroll
		let next = window.scrollY > 40
		if next !== scrolled
			scrolled = next
			imba.commit!

	def onDocClick e
		if moreOpen and !self.contains(e.target)
			moreOpen = false
			imba.commit!

	def onKey e
		if e.key === 'Escape' and moreOpen
			moreOpen = false
			imba.commit!

	def mount
		#onScroll = onScroll.bind(self)
		#onDocClick = onDocClick.bind(self)
		#onKey = onKey.bind(self)
		window.addEventListener('scroll', #onScroll, { passive: true })
		document.addEventListener('click', #onDocClick)
		document.addEventListener('keydown', #onKey)
		onScroll!

	def unmount
		window.removeEventListener('scroll', #onScroll)
		document.removeEventListener('click', #onDocClick)
		document.removeEventListener('keydown', #onKey)

	def go item
		moreOpen = false
		imba.router.go(item.route)

	<self.nav-topbar .scrolled=scrolled>
		# the home page header already says "Grace Lutheran Church"
		unless selected === '/'
			<a.brand @click=go({ route: '/' })> "Grace Lutheran"
		<nav.links>
			for item in navItems
				if item.children
					<div.more>
						<button.link .active=item.children.some(do(c) c.route === selected) .open=moreOpen @click=(moreOpen = !moreOpen) aria-expanded=moreOpen aria-haspopup="true">
							item.label
							<i.fa.fa-chevron-down.caret>
						if moreOpen
							<div.menu>
								for child in item.children
									if child.route
										<a.menu-item .active=(child.route === selected) @click=go(child)>
											<i.fa-fw.fa-{child.icon} .fa=!child.brand .fab=child.brand>
											<span> child.label
									else
										<a.menu-item href=child.url target="_blank" rel="noopener noreferrer" @click=(moreOpen = false)>
											<i.fa-fw.fa-{child.icon} .fa=!child.brand .fab=child.brand>
											<span> child.label
											<i.fa.fa-external-link-alt.ext>
				elif item.route
					<a.link @click=go(item) .active=(item.route === selected)> item.label
				else
					<a.link href=item.url target="_blank" rel="noopener noreferrer"> item.label

css .nav-topbar
	pos:fixed top:0 left:0 right:0 zi:1100
	d:flex ai:center gap:1.5em
	d@lt-md:none
	px:1.5em h:64px
	bg:linear-gradient(to bottom, rgba(0,0,0,.7), rgba(0,0,0,0))
	transition:background .3s ease, box-shadow .3s ease
	.brand
		fw:900 fs:1.3em c:white td:none cursor:pointer ws:nowrap
		ts:0 1px 3px rgba(0,0,0,.6)
	.links
		d:flex ai:center gap:.25em ml:auto
	.link
		d:flex ai:center gap:.4em
		c:white td:none fw:600 fs:1.05em ws:nowrap cursor:pointer
		px:.75em py:.4em rd:full
		bgc:transparent @hover:white/20% bd:none ff:inherit
		ts:0 1px 3px rgba(0,0,0,.6)
		&.active bgc:white/25%
		.caret fs:.7em transition:transform .2s ease
		&.open .caret transform:rotate(180deg)
	.more
		pos:relative
	.menu
		pos:absolute top:calc(100% + .5em) right:0
		min-width:230px py:.4em
		bgc:white rd:.75em
		box-shadow:0 10px 30px rgba(0,0,0,.25)
	.menu-item
		d:flex ai:center gap:.75em
		px:1em py:.6em
		c:cooler8 td:none fw:500 cursor:pointer ws:nowrap
		bgc@hover:cooler1
		i c:red6
		&.active bgc:amber1
		.ext fs:.7em c:cooler4 ml:auto

	&.scrolled
		bg:white
		box-shadow:0 2px 12px rgba(0,0,0,.15)
		.brand c:cooler9 ts:none
		.link c:cooler8 ts:none bgc@hover:cooler1
		.link.active bgc:amber2
